export var CODE_VARIANTS = {
  JS: 'JS',
  TS: 'TS'
};
export var CODE_STYLING = {
  SYSTEM: 'MUI System',
  TAILWIND: 'Tailwind',
  CSS: 'CSS'
};

// Valid languages to use in production
export var LANGUAGES_LABEL = [{
  code: 'en',
  text: 'English'
}];